module.exports = __webpack_public_path__ + "img/img-1.1be4e63f.png";